export default __webpack_public_path__ + "static/media/logo-golden.581b08cb.svg";